import { clocksNow, elapsed, ResourceType as ResourceTypeEnum, toServerDuration } from '@datadog/browser-core';
import { RumEventType } from '../../rawRumEvent.types';
import { sanitizeIfLongDataUrl } from './resourceUtils';
export function trackManualResources(lifeCycle, resourceTracker) {
    function startManualResource(url, options = {}, startClocks = clocksNow()) {
        var _a;
        const lookupKey = (_a = options.resourceKey) !== null && _a !== void 0 ? _a : url;
        resourceTracker.start(lookupKey, startClocks, {
            url,
            ...options,
        });
    }
    function stopManualResource(url, options = {}, stopClocks = clocksNow()) {
        var _a;
        const lookupKey = (_a = options.resourceKey) !== null && _a !== void 0 ? _a : url;
        const stopped = resourceTracker.stop(lookupKey, stopClocks, {
            context: options.context,
            type: options.type,
        });
        if (!stopped) {
            return;
        }
        const duration = elapsed(stopped.startClocks.relative, stopClocks.relative);
        const rawRumEvent = {
            date: stopped.startClocks.timeStamp,
            type: RumEventType.RESOURCE,
            resource: {
                id: stopped.id,
                type: stopped.type || ResourceTypeEnum.OTHER,
                url: sanitizeIfLongDataUrl(stopped.url),
                duration: toServerDuration(duration),
                method: stopped.method,
                status_code: options.statusCode,
                size: options.size,
            },
            _dd: {},
            context: stopped.context,
        };
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
            rawRumEvent,
            startClocks: stopped.startClocks,
            duration,
            domainContext: { isManual: true },
        });
    }
    return {
        startResource: startManualResource,
        stopResource: stopManualResource,
    };
}
//# sourceMappingURL=trackManualResources.js.map